import React, { Component } from 'react';
import Layout from '../Components/Layout';
import CreateRecordModal from '../Components/CreateRecordModal';
import axios from 'axios';
import './Overview.css';

class Overview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            kanbanData: {
                rfq: [],
                rnd: [],
                draftPurchReview: [],
                draftAcctMgmtReview: [],
                draftMgmtReview: [],
                finalQuote: [],
                quoteSubmitted: []
            },
            draggedItemHeight: 0,
            showCreateModal: false,
            showLoadExistingModal: false,
            showFilterModal: false,
            filterConditions: [],
            appliedFilters: [],
            appliedFiltersCount: 0,
            searchText: '',
            loading: true,
            itemNumbers: [],
            itemNumber: '',
            itemNumberSearch: '',
            selectedRfqId: null,
            selectedSharepointLink: '',
            customers: [],
            selectedCustomer: null,
            customerSearch: '',
            selectedOrderType: '',
            showItemDropdown: false,
            showCustomerDropdown: false,
            isDragging: false,
            showMenuDropdown: false,
            itemNumbersLoading: false,
            filterCustomerSearch: {},
            showFilterCustomerDropdown: {},
            filterDealTypeSearch: {},
            showFilterDealTypeDropdown: {},
            filterAssignedToSearch: {},
            showFilterAssignedToDropdown: {},
            assignedToUsers: [],
            filterPurchasingSearch: {},
            showFilterPurchasingDropdown: {},
            purchasingUsers: [],
            filterSalesRepSearch: {},
            showFilterSalesRepDropdown: {},
            salesReps: [],
            filterQuotePrioritySearch: {},
            showFilterQuotePriorityDropdown: {},
            filterDropdownPosition: {}
        };
        this.dragOverTimeout = null;
        this.scrollInterval = null;
        this.searchTimeout = null;
        this.filterInputRefs = {};
    }

    componentDidMount() {
        // Load kanban data and customers on initial page load
        this.loadKanbanData();
        this.loadCustomers();
        this.loadItemNumbers();
        this.loadAssignedToUsers();
        this.loadPurchasingUsers();
        this.loadSalesReps();
    }

    componentWillUnmount() {
        // Clean up timeouts
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }
        if (this.dragOverTimeout) {
            clearTimeout(this.dragOverTimeout);
        }
        if (this.scrollInterval) {
            clearInterval(this.scrollInterval);
        }
    }

    loadKanbanData = async (filters = null, searchText = '') => {
        try {
            let url = '/rfq/kanban';
            const params = [];

            if (filters && filters.length > 0) {
                const filtersParam = encodeURIComponent(JSON.stringify(filters));
                params.push(`filters=${filtersParam}`);
            }

            if (searchText && searchText.trim() !== '') {
                params.push(`search=${encodeURIComponent(searchText.trim())}`);
            }

            if (params.length > 0) {
                url += `?${params.join('&')}`;
            }

            const response = await axios.get(url);
            if (response.data) {
                this.setState({
                    kanbanData: response.data,
                    loading: false
                });
            }
        } catch (error) {
            console.error('Error loading kanban data:', error);
            this.setState({ loading: false });
        }
    }

    updateSortOrder = async (columnKey, items) => {
        try {
            // Extract RFQ IDs in the current order
            const rfqIds = items.map(item => item.id);

            // Map column keys to status numbers
            const columnToStatus = {
                'rfq': 1,
                'rnd': 2,
                'draftPurchReview': 3,
                'draftAcctMgmtReview': 4,
                'draftMgmtReview': 5,
                'finalQuote': 6,
                'quoteSubmitted': 7
            };

            console.log('Updating sort order for column:', columnKey, 'Status:', columnToStatus[columnKey], 'IDs:', rfqIds);

            // Send to backend
            const response = await axios.put('/rfq/update-sort-order', {
                rfq_ids: rfqIds,
                status: columnToStatus[columnKey]
            });

            console.log('Sort order update response:', response.data);

            if (!response.data.success) {
                console.error('Sort order update failed:', response.data);
                alert('Failed to update sort order');
            }
        } catch (error) {
            console.error('Error updating sort order:', error);
            console.error('Error details:', error.response?.data);
            alert('Error updating sort order: ' + (error.response?.data?.detail || error.message));
        }
    }

    colorPalette = [
        { backgroundColor: '#FF6B6B', color: '#FFFFFF' },
        { backgroundColor: '#FFA07A', color: '#000000' },
        { backgroundColor: '#98D8C8', color: '#000000' },
        { backgroundColor: '#F7DC6F', color: '#000000' },
        { backgroundColor: '#85C1E2', color: '#000000' },
        { backgroundColor: '#F8B739', color: '#000000' },
        { backgroundColor: '#52B788', color: '#000000' },
        { backgroundColor: '#E63946', color: '#FFFFFF' },
        { backgroundColor: '#2A9D8F', color: '#FFFFFF' },
        { backgroundColor: '#E76F51', color: '#FFFFFF' },
        { backgroundColor: '#8338EC', color: '#FFFFFF' },
        { backgroundColor: '#3A86FF', color: '#FFFFFF' },
        { backgroundColor: '#FB5607', color: '#FFFFFF' },
        { backgroundColor: '#FFBE0B', color: '#000000' },
        { backgroundColor: '#06FFA5', color: '#000000' },
        { backgroundColor: '#FF006E', color: '#FFFFFF' },
        { backgroundColor: '#7c37ef', color: '#FFFFFF' },
        { backgroundColor: '#9ae095', color: '#000000' },
        { backgroundColor: '#166ee1', color: '#FFFFFF' },
        { backgroundColor: '#ffa6c1', color: '#000000' },
        { backgroundColor: '#dc043b', color: '#FFFFFF' },
        { backgroundColor: '#47061a', color: '#FFFFFF' },
        { backgroundColor: '#944d37', color: '#FFFFFF' },
        { backgroundColor: '#ab0a83', color: '#FFFFFF' },
        { backgroundColor: '#1c0d18', color: '#FFFFFF' },
        { backgroundColor: '#74ebe1', color: '#000000' },
        { backgroundColor: '#006400', color: '#FFFFFF' },
    ];

    getRandomColor = (str) => {
        // Generate a consistent color based on the string value
        if (!str) return this.colorPalette[0];

        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }

        const index = Math.abs(hash) % this.colorPalette.length;
        return this.colorPalette[index];
    }

    handleDragStart = (e, item, sourceColumn, index) => {
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', JSON.stringify({ item, sourceColumn, index }));

        // Store the height of the dragged item
        const itemHeight = e.currentTarget.offsetHeight;
        this.setState({ draggedItemHeight: itemHeight, isDragging: true });

        // Create a clone of the element for the drag image
        const dragElement = e.currentTarget.cloneNode(true);
        dragElement.style.position = 'absolute';
        dragElement.style.top = '-9999px';
        dragElement.style.width = e.currentTarget.offsetWidth + 'px';
        dragElement.style.opacity = '1';
        document.body.appendChild(dragElement);

        e.dataTransfer.setDragImage(dragElement, e.nativeEvent.offsetX, e.nativeEvent.offsetY);

        // Clean up the cloned element after drag starts
        setTimeout(() => {
            document.body.removeChild(dragElement);
        }, 0);

        // Add dragging class to current element
        e.currentTarget.classList.add('dragging');
    }

    handleDragEnd = (e) => {
        e.currentTarget.classList.remove('dragging');

        // Clear last drag over key
        this.lastDragOverKey = null;

        // Stop auto-scrolling
        this.stopAutoScroll();

        // Remove all drag-over indicators
        document.querySelectorAll('.drag-over-top, .drag-over-bottom').forEach(el => {
            el.classList.remove('drag-over-top', 'drag-over-bottom');
            el.style.marginTop = '';
            el.style.marginBottom = '';
        });
        // Reset dragged item height and isDragging flag
        this.setState({ draggedItemHeight: 0, isDragging: false });
    }

    handleDragOver = (e) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';

        // Auto-scroll logic
        this.autoScroll(e);
    }

    autoScroll = (e) => {
        const scrollThreshold = 100; // Distance from edge to trigger scroll
        const scrollSpeed = 10; // Pixels to scroll per interval

        // Clear existing scroll interval
        if (this.scrollInterval) {
            clearInterval(this.scrollInterval);
            this.scrollInterval = null;
        }

        // Get kanban board container
        const kanbanBoard = document.querySelector('.kanban-board');
        if (!kanbanBoard) return;

        const boardRect = kanbanBoard.getBoundingClientRect();
        const mouseX = e.clientX;
        const mouseY = e.clientY;

        let scrollX = 0;
        let scrollY = 0;

        // Check horizontal scrolling
        if (mouseX < boardRect.left + scrollThreshold) {
            // Scroll left
            scrollX = -scrollSpeed;
        } else if (mouseX > boardRect.right - scrollThreshold) {
            // Scroll right
            scrollX = scrollSpeed;
        }

        // Check vertical scrolling within columns
        const columnUnderMouse = document.elementFromPoint(mouseX, mouseY)?.closest('.kanban-column');
        if (columnUnderMouse) {
            const columnRect = columnUnderMouse.getBoundingClientRect();
            const kanbanItems = columnUnderMouse.querySelector('.kanban-items');

            if (kanbanItems) {
                if (mouseY < columnRect.top + scrollThreshold) {
                    // Scroll up
                    scrollY = -scrollSpeed;
                } else if (mouseY > columnRect.bottom - scrollThreshold) {
                    // Scroll down
                    scrollY = scrollSpeed;
                }
            }
        }

        // Start scrolling if needed
        if (scrollX !== 0 || scrollY !== 0) {
            this.scrollInterval = setInterval(() => {
                if (scrollX !== 0) {
                    kanbanBoard.scrollLeft += scrollX;
                }

                if (scrollY !== 0 && columnUnderMouse) {
                    const kanbanItems = columnUnderMouse.querySelector('.kanban-items');
                    if (kanbanItems) {
                        kanbanItems.scrollTop += scrollY;
                    }
                }
            }, 20);
        }
    }

    stopAutoScroll = () => {
        if (this.scrollInterval) {
            clearInterval(this.scrollInterval);
            this.scrollInterval = null;
        }
    }

    handleDragOverCard = (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log('Dragging over card');

        const card = e.currentTarget;
        const rect = card.getBoundingClientRect();
        const midPoint = rect.top + rect.height / 2;
        const mouseY = e.clientY;
        const draggedHeight = this.state.draggedItemHeight;

        // Calculate which half we're in
        const isTop = mouseY < midPoint;

        // Get unique identifier for this card and position
        const cardKey = card.dataset.cardKey || '';
        const currentKey = `${cardKey}-${isTop ? 'top' : 'bottom'}`;

        // Only update if we've moved to a different position
        if (this.lastDragOverKey !== currentKey) {
            this.lastDragOverKey = currentKey;

            // Remove ALL previous indicators immediately
            document.querySelectorAll('.drag-over-top, .drag-over-bottom').forEach(el => {
                el.classList.remove('drag-over-top', 'drag-over-bottom');
                el.style.marginTop = '';
                el.style.marginBottom = '';
            });

            // Apply new state
            if (isTop) {
                card.classList.add('drag-over-top');
                card.style.marginTop = `${draggedHeight + 8}px`;
            } else {
                card.classList.add('drag-over-bottom');
                card.style.marginBottom = `${draggedHeight + 8}px`;
            }
        }
    }

    handleDragLeaveCard = (e) => {
        // Don't remove on leave, only when entering a new card
        // This prevents flickering between cards
    }

    handleDropOnCard = async (e, targetColumn, targetIndex) => {
        console.log('=== handleDropOnCard called ===', targetColumn, targetIndex);

        // Mark that we're handling this drop on a card
        this.droppingOnCard = true;
        console.log('Set droppingOnCard flag to true');

        e.preventDefault();
        e.stopPropagation();

        // Stop auto-scrolling
        this.stopAutoScroll();

        // Remove drag-over indicators
        document.querySelectorAll('.drag-over-top, .drag-over-bottom').forEach(el => {
            el.classList.remove('drag-over-top', 'drag-over-bottom');
            el.style.marginTop = '';
            el.style.marginBottom = '';
        });

        const data = JSON.parse(e.dataTransfer.getData('text/plain'));
        const { item, sourceColumn, index: sourceIndex } = data;

        // Calculate if we should insert before or after the target
        const card = e.currentTarget;
        const rect = card.getBoundingClientRect();
        const midPoint = rect.top + rect.height / 2;
        const mouseY = e.clientY;
        const insertBefore = mouseY < midPoint;

        // Adjust target index based on position
        let adjustedIndex = insertBefore ? targetIndex : targetIndex + 1;

        // Update local state
        const newKanbanData = { ...this.state.kanbanData };

        console.log('Drop on card - sourceColumn:', sourceColumn, 'targetColumn:', targetColumn);
        console.log('sourceIndex:', sourceIndex, 'targetIndex:', targetIndex, 'adjustedIndex:', adjustedIndex);

        if (sourceColumn === targetColumn) {
            // Reordering within the same column
            const items = [...newKanbanData[sourceColumn]];
            console.log('Items before reorder:', items.map(i => i.id));

            const [removed] = items.splice(sourceIndex, 1);
            console.log('Removed item:', removed.id);

            // Adjust index if dragging down within same column
            if (sourceIndex < adjustedIndex) {
                adjustedIndex--;
                console.log('Adjusted index down to:', adjustedIndex);
            }

            items.splice(adjustedIndex, 0, removed);
            console.log('Items after reorder:', items.map(i => i.id));

            newKanbanData[sourceColumn] = items;
            this.setState({ kanbanData: newKanbanData }, () => {
                console.log('State updated, new items:', this.state.kanbanData[sourceColumn].map(i => i.id));
            });

            // Update sort order in database
            console.log('Calling updateSortOrder...');
            await this.updateSortOrder(sourceColumn, items);
        } else {
            // Moving to different column
            console.log('Moving to different column');
            await this.handleDrop(e, targetColumn, adjustedIndex, data);
        }
    }

    handleDrop = async (e, targetColumn, targetIndex = null, dragData = null) => {
        // If dropping on a card, let handleDropOnCard handle it
        console.log('=== handleDrop called === targetColumn:', targetColumn, 'targetIndex:', targetIndex, 'droppingOnCard flag:', this.droppingOnCard);

        if (this.droppingOnCard) {
            console.log('Drop on card detected, skipping handleDrop');
            this.droppingOnCard = false;
            return;
        }

        e.preventDefault();

        const data = dragData || JSON.parse(e.dataTransfer.getData('text/plain'));
        const { item, sourceColumn, index: sourceIndex } = data;

        // If dropping on empty space (not on a card), try to find the nearest card
        if (targetIndex === null) {
            // Get all cards in this column
            const columnElement = e.currentTarget;
            const cards = Array.from(columnElement.querySelectorAll('.kanban-card'));

            if (cards.length > 0) {
                // Find the card closest to the drop position
                let closestCard = null;
                let closestDistance = Infinity;
                let insertIndex = null;

                cards.forEach((card, index) => {
                    const rect = card.getBoundingClientRect();
                    const cardCenterY = rect.top + rect.height / 2;
                    const distance = Math.abs(e.clientY - cardCenterY);

                    if (distance < closestDistance) {
                        closestDistance = distance;
                        closestCard = card;
                        // Determine if we should insert before or after
                        insertIndex = e.clientY < cardCenterY ? index : index + 1;
                    }
                });

                // Use the calculated insert index
                targetIndex = insertIndex;
                console.log('Calculated target index:', targetIndex);
            }

            // If same column and no meaningful position change, return
            if (sourceColumn === targetColumn) {
                if (targetIndex === null || targetIndex === sourceIndex || targetIndex === sourceIndex + 1) {
                    return; // No meaningful position change
                }

                console.log('Reordering in same column from', sourceIndex, 'to', targetIndex);

                const newKanbanData = { ...this.state.kanbanData };
                const items = [...newKanbanData[sourceColumn]];

                const [removed] = items.splice(sourceIndex, 1);
                // Adjust index if dragging down
                if (sourceIndex < targetIndex) {
                    targetIndex--;
                }
                items.splice(targetIndex, 0, removed);

                newKanbanData[sourceColumn] = items;
                this.setState({ kanbanData: newKanbanData });

                await this.updateSortOrder(sourceColumn, items);
                return;
            }
        }

        // Map column keys to status numbers
        const columnToStatus = {
            'rfq': 1,
            'rnd': 2,
            'draftPurchReview': 3,
            'draftAcctMgmtReview': 4,
            'draftMgmtReview': 5,
            'finalQuote': 6,
            'quoteSubmitted': 7
        };

        const newStatus = columnToStatus[targetColumn];

        try {
            // Update status in database if moving to different column
            if (sourceColumn !== targetColumn) {
                await axios.put(`/rfq/${item.id}/status`, { status: newStatus });
            }

            // Update local state
            const newKanbanData = { ...this.state.kanbanData };

            // Remove from source
            newKanbanData[sourceColumn] = newKanbanData[sourceColumn].filter(i => i.id !== item.id);

            // Add to target at specific position or end
            if (targetIndex !== null) {
                newKanbanData[targetColumn].splice(targetIndex, 0, item);
            } else {
                newKanbanData[targetColumn].push(item);
            }

            // Update sort order in both columns
            await this.updateSortOrder(targetColumn, newKanbanData[targetColumn]);

            if (sourceColumn !== targetColumn) {
                await this.updateSortOrder(sourceColumn, newKanbanData[sourceColumn]);
            }

            // Reload to get updated identifier and proper sort order when status changes
            if (sourceColumn !== targetColumn) {
                // Add a small delay to ensure database updates are complete
                await new Promise(resolve => setTimeout(resolve, 100));
                await this.loadKanbanData();
            } else {
                // For same column moves, just update state
                this.setState({ kanbanData: newKanbanData });
            }
        } catch (error) {
            console.error('Error updating RFQ status:', error);
            alert('Failed to update RFQ status');
        }
    }

    getTeamMemberLabel = (columnKey) => {
        const labels = {
            'rfq': 'Sales Rep',
            'rnd': 'Assigned To',
            'draftPurchReview': 'Purchasing Team Member',
            'draftAcctMgmtReview': 'Account Manager',
            'draftMgmtReview': 'Reviewed By',
            'finalQuote': 'Reviewed By',
            'quoteSubmitted': 'Reviewed By'
        };
        return labels[columnKey] || 'Team Member';
    }

    getAmountLabel = (columnKey) => {
        if (columnKey === 'rfq') {
            return 'Estimated Value';
        }
        return 'Total Price';
    }

    getNavigationUrl = (status, rfqId) => {
        if (status === 1) {
            return `/request-quote/edit?id=${rfqId}`;
        } else if (status === 2) {
            return `/formula/edit?id=${rfqId}`;
        } else if (status === 3 || status === 4 || status === 5) {
            return `/draft-estimate/edit?id=${rfqId}`;
        } else if (status === 6 || status === 7) {
            return `/estimate/edit?id=${rfqId}`;
        }
        return `/request-quote/edit?id=${rfqId}`; // Default fallback
    }

    handleCardClick = (item, columnKey, e) => {
        // Don't navigate if we're dragging
        if (this.state.isDragging) {
            return;
        }

        // Map columnKey to status
        const statusMap = {
            'rfq': 1,
            'rnd': 2,
            'draftPurchReview': 3,
            'draftAcctMgmtReview': 4,
            'draftMgmtReview': 5,
            'finalQuote': 6,
            'quoteSubmitted': 7
        };

        const status = statusMap[columnKey];
        const url = this.getNavigationUrl(status, item.id);
        window.location.href = url;
    }

    handleCreateClick = () => {
        this.setState({ showCreateModal: true });
    }

    handleMenuClick = () => {
        this.setState({ showMenuDropdown: !this.state.showMenuDropdown });
    }

    handleMenuClose = () => {
        this.setState({ showMenuDropdown: false });
    }

    handleMonthlyShippingClick = () => {
        window.location.href = '/monthly-shipping-cost';
    }

    handleAllJobsClick = () => {
        window.location.href = '/all-jobs';
    }

    handleCloseModal = () => {
        this.setState({ showCreateModal: false });
    }

    handleFilterClick = () => {
        // Load existing applied filters when opening the modal
        const filterConditions = this.state.appliedFilters.length > 0 ? [...this.state.appliedFilters] : [];

        // Initialize filterCustomerSearch as empty - badges will show selected customers
        const filterCustomerSearch = {};

        this.setState({
            showFilterModal: true,
            filterConditions,
            filterCustomerSearch,
            showFilterCustomerDropdown: {}
        });
    }

    handleCloseFilterModal = () => {
        this.setState({
            showFilterModal: false,
            filterConditions: [],
            filterCustomerSearch: {},
            showFilterCustomerDropdown: {},
            filterDealTypeSearch: {},
            showFilterDealTypeDropdown: {},
            filterAssignedToSearch: {},
            showFilterAssignedToDropdown: {},
            filterPurchasingSearch: {},
            showFilterPurchasingDropdown: {},
            filterSalesRepSearch: {},
            showFilterSalesRepDropdown: {},
            filterQuotePrioritySearch: {},
            showFilterQuotePriorityDropdown: {}
        });
    }

    handleApplyFilter = () => {
        const validFilters = this.state.filterConditions.filter(
            condition => condition.field !== 'Select field' && (condition.value !== '' || ['is empty...', 'is not empty'].includes(condition.operator))
        );
        this.setState({
            appliedFilters: validFilters,
            appliedFiltersCount: validFilters.length,
            showFilterModal: false,
            loading: true
        }, () => {
            // Reload kanban data with filters and search text
            this.loadKanbanData(validFilters, this.state.searchText);
        });
    }

    handleSearchChange = (e) => {
        const searchText = e.target.value;
        this.setState({ searchText });

        // Clear any existing timeout
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }

        // Set a new timeout to trigger search after user stops typing
        this.searchTimeout = setTimeout(() => {
            this.setState({ loading: true }, () => {
                this.loadKanbanData(this.state.appliedFilters, searchText);
            });
        }, 500); // Wait 500ms after user stops typing
    }

    handleSearchClear = () => {
        this.setState({ searchText: '', loading: true }, () => {
            this.loadKanbanData(this.state.appliedFilters, '');
        });
    }

    handleAddCondition = () => {
        this.setState({
            filterConditions: [...this.state.filterConditions, { field: 'Select field', operator: 'Equals', value: '' }]
        });
    }

    handleFieldChange = (index, value) => {
        const newConditions = [...this.state.filterConditions];
        newConditions[index].field = value;
        // Reset operator to appropriate default when field changes
        if (value === 'Deal Type' || value === 'Customer' || value === 'Assigned To' || value === 'Purchasing Team Member' || value === 'Sales Rep' || value === 'Quote Priority') {
            newConditions[index].operator = 'is...';
        } else {
            newConditions[index].operator = 'Equals';
        }
        // Clear value when field changes
        newConditions[index].value = '';
        this.setState({ filterConditions: newConditions });
    }

    handleOperatorChange = (index, value) => {
        const newConditions = [...this.state.filterConditions];
        const previousOperator = newConditions[index].operator;
        newConditions[index].operator = value;

        // Clear value when switching to empty check operators
        if (value === 'is empty...' || value === 'is not empty') {
            newConditions[index].value = '';
        }

        // Clear value when switching between single and multi-select operators
        const field = newConditions[index].field;
        if (field === 'Customer' || field === 'Deal Type' || field === 'Assigned To' || field === 'Purchasing Team Member' || field === 'Sales Rep' || field === 'Quote Priority') {
            const singleSelectOps = ['is...', 'is not...'];
            const multiSelectOps = ['is any of...', 'is none of...'];

            // Switching from single to multi or vice versa
            if ((singleSelectOps.includes(previousOperator) && multiSelectOps.includes(value)) ||
                (multiSelectOps.includes(previousOperator) && singleSelectOps.includes(value))) {
                newConditions[index].value = '';
            }
        }

        this.setState({ filterConditions: newConditions });
    }

    handleValueChange = (index, value) => {
        const newConditions = [...this.state.filterConditions];
        newConditions[index].value = value;
        this.setState({ filterConditions: newConditions });
    }

    handleRemoveCondition = (index) => {
        const newConditions = this.state.filterConditions.filter((_, i) => i !== index);
        this.setState({ filterConditions: newConditions });
    }

    handleClearAllFilters = () => {
        this.setState({ filterConditions: [] });
    }

    handleClearAndApplyFilters = () => {
        this.setState({
            filterConditions: [],
            appliedFilters: [],
            appliedFiltersCount: 0,
            showFilterModal: false,
            loading: true
        }, () => {
            // Reload kanban data without filters but keep search text
            this.loadKanbanData([], this.state.searchText);
        });
    }


    loadItemNumbers = async () => {
        try {
            this.setState({ itemNumbersLoading: true });
            const response = await axios.get('/rfq/airtable-formulas');
            if (response.data && response.data.success) {
                // Transform the Airtable data to match the expected format
                // Filter out items with null names
                const itemNumbers = response.data.data
                    .filter(item => item.name != null)
                    .map(item => ({
                        itemNumber: item.name,
                        rfqId: item.id,
                        sharepointLink: item.sharepointLink
                    }));
                this.setState({ itemNumbers: itemNumbers, itemNumbersLoading: false });
            } else {
                this.setState({ itemNumbersLoading: false });
            }
        } catch (error) {
            console.error('Error loading item numbers:', error);
            this.setState({ itemNumbersLoading: false });
        }
    }

    loadCustomers = async () => {
        try {
            const response = await axios.get('/customer-list-databricks');

            if (response.data && response.data.data && Array.isArray(response.data.data)) {
                // Store full customer objects, filtered for those with customer_name
                const customers = response.data.data
                    .filter(customer => customer.customer_name)
                    .sort((a, b) => a.customer_name.localeCompare(b.customer_name));

                this.setState({ customers: customers });
            }
        } catch (error) {
            console.error('Error loading customers:', error);
        }
    }

    loadAssignedToUsers = async () => {
        try {
            const response = await axios.get('/assigned-to');

            if (response.data && response.data.status === 'success' && Array.isArray(response.data.data)) {
                const users = response.data.data.sort((a, b) => a.fullname.localeCompare(b.fullname));
                this.setState({ assignedToUsers: users });
            }
        } catch (error) {
            console.error('Error loading assigned to users:', error);
        }
    }

    loadPurchasingUsers = async () => {
        try {
            const response = await axios.get('/purch-review-reps');

            if (response.data && response.data.status === 'success' && Array.isArray(response.data.data)) {
                const users = response.data.data.sort((a, b) => a.fullname.localeCompare(b.fullname));
                this.setState({ purchasingUsers: users });
            }
        } catch (error) {
            console.error('Error loading purchasing users:', error);
        }
    }

    loadSalesReps = async () => {
        try {
            const response = await axios.get('/sales-reps');

            if (response.data && response.data.status === 'success' && Array.isArray(response.data.data)) {
                const reps = response.data.data.sort((a, b) => a.fullname.localeCompare(b.fullname));
                this.setState({ salesReps: reps });
            }
        } catch (error) {
            console.error('Error loading sales reps:', error);
        }
    }

    handleCloseLoadExistingModal = () => {
        this.setState({
            showLoadExistingModal: false,
            itemNumber: '',
            itemNumberSearch: '',
            selectedRfqId: null,
            selectedSharepointLink: '',
            selectedCustomer: null,
            customerSearch: '',
            selectedOrderType: '',
            showItemDropdown: false,
            showCustomerDropdown: false
        });
    }

    handleItemNumberSearchChange = (e) => {
        this.setState({
            itemNumberSearch: e.target.value,
            showItemDropdown: true
        });
    }

    handleItemNumberSelect = (item) => {
        this.setState({
            itemNumber: item.itemNumber,
            itemNumberSearch: item.itemNumber,
            selectedRfqId: item.rfqId,
            selectedSharepointLink: item.sharepointLink || '',
            showItemDropdown: false
        });
    }

    handleItemNumberFocus = () => {
        this.setState({ showItemDropdown: true });
    }

    handleItemNumberBlur = () => {
        // Delay to allow click on dropdown item
        setTimeout(() => {
            this.setState({ showItemDropdown: false });
        }, 200);
    }

    handleCustomerSearchChange = (e) => {
        this.setState({
            customerSearch: e.target.value,
            showCustomerDropdown: true
        });
    }

    handleCustomerSelect = (customer) => {
        this.setState({
            selectedCustomer: customer,
            customerSearch: customer.customer_name,
            showCustomerDropdown: false
        });
    }

    handleCustomerFocus = () => {
        this.setState({ showCustomerDropdown: true });
    }

    handleCustomerBlur = () => {
        // Delay to allow click on dropdown item
        setTimeout(() => {
            this.setState({ showCustomerDropdown: false });
        }, 200);
    }

    handleOrderTypeChange = (e) => {
        this.setState({ selectedOrderType: e.target.value });
    }

    handleLoadExistingSubmit = async () => {
        const { selectedRfqId, itemNumber, selectedSharepointLink, selectedCustomer, selectedOrderType } = this.state;

        console.log('Customer object being sent:', selectedCustomer);

        try {
            const response = await axios.post('/store-to-temp-and-loadrfq', {
                id: selectedRfqId,
                itemNumber: itemNumber,
                sharepointLink: selectedSharepointLink,
                customer: selectedCustomer,
                orderType: selectedOrderType
            });

            if (response.data && response.data.success) {
                const rfqTempId = response.data.rfqTempId;
                // Navigate to edit page with temp RFQ ID
                window.location.href = `/request-quote/new?tempId=${rfqTempId}`;
            }
        } catch (error) {
            console.error('Error creating RFQ from existing:', error);
            alert('Failed to create RFQ. Please try again.');
        }
    }

    getFilteredItemNumbers = () => {
        const { itemNumbers, itemNumberSearch } = this.state;
        if (!itemNumberSearch) return itemNumbers;
        return itemNumbers.filter(item =>
            item.itemNumber.toLowerCase().includes(itemNumberSearch.toLowerCase())
        );
    }

    getFilteredCustomers = () => {
        const { customers, customerSearch } = this.state;
        if (!customerSearch) return customers;
        return customers.filter(customer =>
            customer.customer_name.toLowerCase().includes(customerSearch.toLowerCase())
        );
    }

    getFilteredCustomersForFilter = (index) => {
        const { customers, filterCustomerSearch } = this.state;
        const searchText = filterCustomerSearch[index] || '';
        if (!searchText) return customers;
        return customers.filter(customer =>
            customer.customer_name.toLowerCase().includes(searchText.toLowerCase())
        );
    }

    handleFilterCustomerSearchChange = (index, value) => {
        this.setState({
            filterCustomerSearch: {
                ...this.state.filterCustomerSearch,
                [index]: value
            },
            showFilterCustomerDropdown: {
                ...this.state.showFilterCustomerDropdown,
                [index]: true
            }
        });
    }

    handleFilterCustomerSelect = (index, customerName) => {
        const currentCondition = this.state.filterConditions[index];
        const currentValue = currentCondition.value;
        const currentSelections = currentValue ? currentValue.split('|||').map(s => s.trim()) : [];
        const operator = currentCondition.operator;

        // For single-select operators (is..., is not...), only allow one selection
        const isSingleSelect = ['is...', 'is not...'].includes(operator);

        let newSelections;
        if (isSingleSelect) {
            // Single select: replace with new selection and close dropdown
            newSelections = [customerName];
            const newValue = newSelections.join('|||');
            this.handleValueChange(index, newValue);

            // Clear search and close dropdown for single select
            this.setState({
                filterCustomerSearch: {
                    ...this.state.filterCustomerSearch,
                    [index]: ''
                },
                showFilterCustomerDropdown: {
                    ...this.state.showFilterCustomerDropdown,
                    [index]: false
                }
            });
        } else {
            // Multi-select: toggle selection
            if (currentSelections.includes(customerName)) {
                newSelections = currentSelections.filter(name => name !== customerName);
            } else {
                newSelections = [...currentSelections, customerName];
            }

            const newValue = newSelections.join('|||');
            this.handleValueChange(index, newValue);

            // Clear search but keep dropdown open for multi-select
            this.setState({
                filterCustomerSearch: {
                    ...this.state.filterCustomerSearch,
                    [index]: ''
                }
            });
        }
    }

    handleRemoveCustomerFromFilter = (index, customerName) => {
        const currentValue = this.state.filterConditions[index].value;
        const currentSelections = currentValue ? currentValue.split('|||').map(s => s.trim()) : [];
        const newSelections = currentSelections.filter(name => name !== customerName);
        const newValue = newSelections.join('|||');
        this.handleValueChange(index, newValue);
    }

    handleFilterCustomerFocus = (index) => {
        const inputElement = this.filterInputRefs[index];
        if (inputElement) {
            const rect = inputElement.getBoundingClientRect();
            this.setState({
                showFilterCustomerDropdown: {
                    ...this.state.showFilterCustomerDropdown,
                    [index]: true
                },
                filterDropdownPosition: {
                    ...this.state.filterDropdownPosition,
                    [index]: {
                        top: rect.bottom,
                        left: rect.left,
                        width: rect.width
                    }
                }
            });
        } else {
            this.setState({
                showFilterCustomerDropdown: {
                    ...this.state.showFilterCustomerDropdown,
                    [index]: true
                }
            });
        }
    }

    handleFilterCustomerBlur = (index) => {
        setTimeout(() => {
            this.setState({
                showFilterCustomerDropdown: {
                    ...this.state.showFilterCustomerDropdown,
                    [index]: false
                }
            });
        }, 200);
    }

    // Deal Type filter handlers
    getDealTypeOptions = (index) => {
        const dealTypes = ['Sales Order (SO)', 'Invoice', 'Lost (Dead)', 'SO Cancelled', 'Quotation/Estimation', 'Rework', 'PO Accepted'];
        const searchText = this.state.filterDealTypeSearch?.[index] || '';
        if (!searchText) return dealTypes;
        return dealTypes.filter(type =>
            type.toLowerCase().includes(searchText.toLowerCase())
        );
    }

    handleFilterDealTypeSearchChange = (index, value) => {
        this.setState({
            filterDealTypeSearch: {
                ...this.state.filterDealTypeSearch,
                [index]: value
            },
            showFilterDealTypeDropdown: {
                ...this.state.showFilterDealTypeDropdown,
                [index]: true
            }
        });
    }

    handleFilterDealTypeSelect = (index, dealType) => {
        const currentCondition = this.state.filterConditions[index];
        const currentValue = currentCondition.value;
        const currentSelections = currentValue ? currentValue.split('|||').map(s => s.trim()) : [];
        const operator = currentCondition.operator;

        // For single-select operators (is..., is not...), only allow one selection
        const isSingleSelect = ['is...', 'is not...'].includes(operator);

        let newSelections;
        if (isSingleSelect) {
            // Single select: replace with new selection and close dropdown
            newSelections = [dealType];
            const newValue = newSelections.join('|||');
            this.handleValueChange(index, newValue);

            // Clear search and close dropdown for single select
            this.setState({
                filterDealTypeSearch: {
                    ...this.state.filterDealTypeSearch,
                    [index]: ''
                },
                showFilterDealTypeDropdown: {
                    ...this.state.showFilterDealTypeDropdown,
                    [index]: false
                }
            });
        } else {
            // Multi-select: toggle selection
            if (currentSelections.includes(dealType)) {
                newSelections = currentSelections.filter(name => name !== dealType);
            } else {
                newSelections = [...currentSelections, dealType];
            }

            const newValue = newSelections.join('|||');
            this.handleValueChange(index, newValue);

            // Clear search but keep dropdown open for multi-select
            this.setState({
                filterDealTypeSearch: {
                    ...this.state.filterDealTypeSearch,
                    [index]: ''
                }
            });
        }
    }

    handleRemoveDealTypeFromFilter = (index, dealType) => {
        const currentValue = this.state.filterConditions[index].value;
        const currentSelections = currentValue ? currentValue.split('|||').map(s => s.trim()) : [];
        const newSelections = currentSelections.filter(name => name !== dealType);
        const newValue = newSelections.join('|||');
        this.handleValueChange(index, newValue);
    }

    handleFilterDealTypeFocus = (index) => {
        const inputElement = this.filterInputRefs[`dealtype_${index}`];
        if (inputElement) {
            const rect = inputElement.getBoundingClientRect();
            this.setState({
                showFilterDealTypeDropdown: {
                    ...this.state.showFilterDealTypeDropdown,
                    [index]: true
                },
                filterDropdownPosition: {
                    ...this.state.filterDropdownPosition,
                    [`dealtype_${index}`]: {
                        top: rect.bottom,
                        left: rect.left,
                        width: rect.width
                    }
                }
            });
        } else {
            this.setState({
                showFilterDealTypeDropdown: {
                    ...this.state.showFilterDealTypeDropdown,
                    [index]: true
                }
            });
        }
    }

    handleFilterDealTypeBlur = (index) => {
        setTimeout(() => {
            this.setState({
                showFilterDealTypeDropdown: {
                    ...this.state.showFilterDealTypeDropdown,
                    [index]: false
                }
            });
        }, 200);
    }

    // Assigned To filter handlers
    getFilteredAssignedToUsers = (index) => {
        const { assignedToUsers, filterAssignedToSearch } = this.state;
        const searchText = filterAssignedToSearch?.[index] || '';
        if (!searchText) return assignedToUsers;
        return assignedToUsers.filter(user =>
            user.fullname.toLowerCase().includes(searchText.toLowerCase())
        );
    }

    handleFilterAssignedToSearchChange = (index, value) => {
        this.setState({
            filterAssignedToSearch: {
                ...this.state.filterAssignedToSearch,
                [index]: value
            },
            showFilterAssignedToDropdown: {
                ...this.state.showFilterAssignedToDropdown,
                [index]: true
            }
        });
    }

    handleFilterAssignedToSelect = (index, userName) => {
        const currentCondition = this.state.filterConditions[index];
        const currentValue = currentCondition.value;
        const currentSelections = currentValue ? currentValue.split('|||').map(s => s.trim()) : [];
        const operator = currentCondition.operator;

        // For single-select operators (is..., is not..., Equals, Contains, etc.), only allow one selection
        const isSingleSelect = ['is...', 'is not...', 'Equals', 'Contains', 'Starts with', 'Ends with'].includes(operator);

        let newSelections;
        if (isSingleSelect) {
            // Single select: replace with new selection and close dropdown
            newSelections = [userName];
            const newValue = newSelections.join('|||');
            this.handleValueChange(index, newValue);

            // Clear search and close dropdown for single select
            this.setState({
                filterAssignedToSearch: {
                    ...this.state.filterAssignedToSearch,
                    [index]: ''
                },
                showFilterAssignedToDropdown: {
                    ...this.state.showFilterAssignedToDropdown,
                    [index]: false
                }
            });
        } else {
            // Multi-select: toggle selection
            if (currentSelections.includes(userName)) {
                newSelections = currentSelections.filter(name => name !== userName);
            } else {
                newSelections = [...currentSelections, userName];
            }

            const newValue = newSelections.join('|||');
            this.handleValueChange(index, newValue);

            // Clear search but keep dropdown open for multi-select
            this.setState({
                filterAssignedToSearch: {
                    ...this.state.filterAssignedToSearch,
                    [index]: ''
                }
            });
        }
    }

    handleRemoveAssignedToFromFilter = (index, userName) => {
        const currentValue = this.state.filterConditions[index].value;
        const currentSelections = currentValue ? currentValue.split('|||').map(s => s.trim()) : [];
        const newSelections = currentSelections.filter(name => name !== userName);
        const newValue = newSelections.join('|||');
        this.handleValueChange(index, newValue);
    }

    handleFilterAssignedToFocus = (index) => {
        const inputElement = this.filterInputRefs[`assignedto_${index}`];
        if (inputElement) {
            const rect = inputElement.getBoundingClientRect();
            this.setState({
                showFilterAssignedToDropdown: {
                    ...this.state.showFilterAssignedToDropdown,
                    [index]: true
                },
                filterDropdownPosition: {
                    ...this.state.filterDropdownPosition,
                    [`assignedto_${index}`]: {
                        top: rect.bottom,
                        left: rect.left,
                        width: rect.width
                    }
                }
            });
        } else {
            this.setState({
                showFilterAssignedToDropdown: {
                    ...this.state.showFilterAssignedToDropdown,
                    [index]: true
                }
            });
        }
    }

    handleFilterAssignedToBlur = (index) => {
        setTimeout(() => {
            this.setState({
                showFilterAssignedToDropdown: {
                    ...this.state.showFilterAssignedToDropdown,
                    [index]: false
                }
            });
        }, 200);
    }

    // Purchasing Team Member filter handlers
    getFilteredPurchasingUsers = (index) => {
        const { purchasingUsers, filterPurchasingSearch } = this.state;
        const searchText = filterPurchasingSearch?.[index] || '';
        if (!searchText) return purchasingUsers;
        return purchasingUsers.filter(user =>
            user.fullname.toLowerCase().includes(searchText.toLowerCase())
        );
    }

    handleFilterPurchasingSearchChange = (index, value) => {
        this.setState({
            filterPurchasingSearch: {
                ...this.state.filterPurchasingSearch,
                [index]: value
            },
            showFilterPurchasingDropdown: {
                ...this.state.showFilterPurchasingDropdown,
                [index]: true
            }
        });
    }

    handleFilterPurchasingSelect = (index, userName) => {
        const currentCondition = this.state.filterConditions[index];
        const currentValue = currentCondition.value;
        const currentSelections = currentValue ? currentValue.split('|||').map(s => s.trim()) : [];
        const operator = currentCondition.operator;

        const isSingleSelect = ['is...', 'is not...', 'Equals', 'Contains', 'Starts with', 'Ends with'].includes(operator);

        let newSelections;
        if (isSingleSelect) {
            newSelections = [userName];
            const newValue = newSelections.join('|||');
            this.handleValueChange(index, newValue);

            this.setState({
                filterPurchasingSearch: {
                    ...this.state.filterPurchasingSearch,
                    [index]: ''
                },
                showFilterPurchasingDropdown: {
                    ...this.state.showFilterPurchasingDropdown,
                    [index]: false
                }
            });
        } else {
            if (currentSelections.includes(userName)) {
                newSelections = currentSelections.filter(name => name !== userName);
            } else {
                newSelections = [...currentSelections, userName];
            }

            const newValue = newSelections.join('|||');
            this.handleValueChange(index, newValue);

            this.setState({
                filterPurchasingSearch: {
                    ...this.state.filterPurchasingSearch,
                    [index]: ''
                }
            });
        }
    }

    handleRemovePurchasingFromFilter = (index, userName) => {
        const currentValue = this.state.filterConditions[index].value;
        const currentSelections = currentValue ? currentValue.split('|||').map(s => s.trim()) : [];
        const newSelections = currentSelections.filter(name => name !== userName);
        const newValue = newSelections.join('|||');
        this.handleValueChange(index, newValue);
    }

    handleFilterPurchasingFocus = (index) => {
        const inputElement = this.filterInputRefs[`purchasing_${index}`];
        if (inputElement) {
            const rect = inputElement.getBoundingClientRect();
            this.setState({
                showFilterPurchasingDropdown: {
                    ...this.state.showFilterPurchasingDropdown,
                    [index]: true
                },
                filterDropdownPosition: {
                    ...this.state.filterDropdownPosition,
                    [`purchasing_${index}`]: {
                        top: rect.bottom,
                        left: rect.left,
                        width: rect.width
                    }
                }
            });
        } else {
            this.setState({
                showFilterPurchasingDropdown: {
                    ...this.state.showFilterPurchasingDropdown,
                    [index]: true
                }
            });
        }
    }

    handleFilterPurchasingBlur = (index) => {
        setTimeout(() => {
            this.setState({
                showFilterPurchasingDropdown: {
                    ...this.state.showFilterPurchasingDropdown,
                    [index]: false
                }
            });
        }, 200);
    }

    // Sales Rep filter handlers
    getFilteredSalesReps = (index) => {
        const { salesReps, filterSalesRepSearch } = this.state;
        const searchText = filterSalesRepSearch?.[index] || '';
        if (!searchText) return salesReps;
        return salesReps.filter(rep =>
            rep.fullname.toLowerCase().includes(searchText.toLowerCase())
        );
    }

    handleFilterSalesRepSearchChange = (index, value) => {
        this.setState({
            filterSalesRepSearch: {
                ...this.state.filterSalesRepSearch,
                [index]: value
            },
            showFilterSalesRepDropdown: {
                ...this.state.showFilterSalesRepDropdown,
                [index]: true
            }
        });
    }

    handleFilterSalesRepSelect = (index, repName) => {
        const currentCondition = this.state.filterConditions[index];
        const currentValue = currentCondition.value;
        const currentSelections = currentValue ? currentValue.split('|||').map(s => s.trim()) : [];
        const operator = currentCondition.operator;

        const isSingleSelect = ['is...', 'is not...', 'Equals', 'Contains', 'Starts with', 'Ends with'].includes(operator);

        let newSelections;
        if (isSingleSelect) {
            newSelections = [repName];
            const newValue = newSelections.join('|||');
            this.handleValueChange(index, newValue);

            this.setState({
                filterSalesRepSearch: {
                    ...this.state.filterSalesRepSearch,
                    [index]: ''
                },
                showFilterSalesRepDropdown: {
                    ...this.state.showFilterSalesRepDropdown,
                    [index]: false
                }
            });
        } else {
            if (currentSelections.includes(repName)) {
                newSelections = currentSelections.filter(name => name !== repName);
            } else {
                newSelections = [...currentSelections, repName];
            }

            const newValue = newSelections.join('|||');
            this.handleValueChange(index, newValue);

            this.setState({
                filterSalesRepSearch: {
                    ...this.state.filterSalesRepSearch,
                    [index]: ''
                }
            });
        }
    }

    handleRemoveSalesRepFromFilter = (index, repName) => {
        const currentValue = this.state.filterConditions[index].value;
        const currentSelections = currentValue ? currentValue.split('|||').map(s => s.trim()) : [];
        const newSelections = currentSelections.filter(name => name !== repName);
        const newValue = newSelections.join('|||');
        this.handleValueChange(index, newValue);
    }

    handleFilterSalesRepFocus = (index) => {
        const inputElement = this.filterInputRefs[`salesrep_${index}`];
        if (inputElement) {
            const rect = inputElement.getBoundingClientRect();
            this.setState({
                showFilterSalesRepDropdown: {
                    ...this.state.showFilterSalesRepDropdown,
                    [index]: true
                },
                filterDropdownPosition: {
                    ...this.state.filterDropdownPosition,
                    [`salesrep_${index}`]: {
                        top: rect.bottom,
                        left: rect.left,
                        width: rect.width
                    }
                }
            });
        } else {
            this.setState({
                showFilterSalesRepDropdown: {
                    ...this.state.showFilterSalesRepDropdown,
                    [index]: true
                }
            });
        }
    }

    handleFilterSalesRepBlur = (index) => {
        setTimeout(() => {
            this.setState({
                showFilterSalesRepDropdown: {
                    ...this.state.showFilterSalesRepDropdown,
                    [index]: false
                }
            });
        }, 200);
    }

    // Quote Priority filter handlers
    getQuotePriorityOptions = (index) => {
        const priorities = [
            '#1 High Priority',
            '#2 PO Reorder',
            '#3 NPD Tier A Customer',
            '#4 Reorder - No PO',
            '#5 New to Apex - Existing Sku',
            '#6 NPD Tier B Customer',
            '#7 Formula Improvement',
            '#8 Low Priority'
        ];
        const searchText = this.state.filterQuotePrioritySearch?.[index] || '';
        if (!searchText) return priorities;
        return priorities.filter(priority =>
            priority.toLowerCase().includes(searchText.toLowerCase())
        );
    }

    handleFilterQuotePrioritySearchChange = (index, value) => {
        this.setState({
            filterQuotePrioritySearch: {
                ...this.state.filterQuotePrioritySearch,
                [index]: value
            },
            showFilterQuotePriorityDropdown: {
                ...this.state.showFilterQuotePriorityDropdown,
                [index]: true
            }
        });
    }

    handleFilterQuotePrioritySelect = (index, priority) => {
        const currentCondition = this.state.filterConditions[index];
        const currentValue = currentCondition.value;
        const currentSelections = currentValue ? currentValue.split('|||').map(s => s.trim()) : [];
        const operator = currentCondition.operator;

        const isSingleSelect = ['is...', 'is not...'].includes(operator);

        let newSelections;
        if (isSingleSelect) {
            newSelections = [priority];
            const newValue = newSelections.join('|||');
            this.handleValueChange(index, newValue);

            this.setState({
                filterQuotePrioritySearch: {
                    ...this.state.filterQuotePrioritySearch,
                    [index]: ''
                },
                showFilterQuotePriorityDropdown: {
                    ...this.state.showFilterQuotePriorityDropdown,
                    [index]: false
                }
            });
        } else {
            if (currentSelections.includes(priority)) {
                newSelections = currentSelections.filter(name => name !== priority);
            } else {
                newSelections = [...currentSelections, priority];
            }

            const newValue = newSelections.join('|||');
            this.handleValueChange(index, newValue);

            this.setState({
                filterQuotePrioritySearch: {
                    ...this.state.filterQuotePrioritySearch,
                    [index]: ''
                }
            });
        }
    }

    handleRemoveQuotePriorityFromFilter = (index, priority) => {
        const currentValue = this.state.filterConditions[index].value;
        const currentSelections = currentValue ? currentValue.split('|||').map(s => s.trim()) : [];
        const newSelections = currentSelections.filter(name => name !== priority);
        const newValue = newSelections.join('|||');
        this.handleValueChange(index, newValue);
    }

    handleFilterQuotePriorityFocus = (index) => {
        const inputElement = this.filterInputRefs[`quotepriority_${index}`];
        if (inputElement) {
            const rect = inputElement.getBoundingClientRect();
            this.setState({
                showFilterQuotePriorityDropdown: {
                    ...this.state.showFilterQuotePriorityDropdown,
                    [index]: true
                },
                filterDropdownPosition: {
                    ...this.state.filterDropdownPosition,
                    [`quotepriority_${index}`]: {
                        top: rect.bottom,
                        left: rect.left,
                        width: rect.width
                    }
                }
            });
        } else {
            this.setState({
                showFilterQuotePriorityDropdown: {
                    ...this.state.showFilterQuotePriorityDropdown,
                    [index]: true
                }
            });
        }
    }

    handleFilterQuotePriorityBlur = (index) => {
        setTimeout(() => {
            this.setState({
                showFilterQuotePriorityDropdown: {
                    ...this.state.showFilterQuotePriorityDropdown,
                    [index]: false
                }
            });
        }, 200);
    }

    renderSkeletonCard = () => {
        return (
            <div className="kanban-card skeleton-card">
                <div className="card-content">
                    <div className="skeleton skeleton-id"></div>
                    <div className="skeleton skeleton-text"></div>
                    <div className="skeleton skeleton-badge"></div>
                    <div className="skeleton skeleton-text"></div>
                    <div className="skeleton skeleton-badge"></div>
                    <div className="skeleton skeleton-text"></div>
                    <div className="skeleton skeleton-badge"></div>
                </div>
            </div>
        );
    }

    renderSkeletonColumn = (title) => {
        return (
            <div className="kanban-column" key={title}>
                <div className="kanban-header">
                    <h5>{title}</h5>
                    <span className="skeleton skeleton-count"></span>
                </div>
                <div className="kanban-items">
                    {this.renderSkeletonCard()}
                    {this.renderSkeletonCard()}
                    {this.renderSkeletonCard()}
                </div>
            </div>
        );
    }

    renderKanbanColumn = (title, items, columnKey) => {
        const teamMemberLabel = this.getTeamMemberLabel(columnKey);
        const amountLabel = this.getAmountLabel(columnKey);

        return (
            <div
                className="kanban-column"
                key={columnKey}
                onDragOver={this.handleDragOver}
                onDrop={(e) => this.handleDrop(e, columnKey)}
            >
                <div className="kanban-header">
                    <h5>{title}</h5>
                    <span className="item-count">{items.length}</span>
                    {columnKey === 'rfq' && <i className="ti-plus" style={{ marginLeft: '8px', cursor: 'pointer' }} onClick={this.handleCreateClick}></i>}
                </div>
                <div className="kanban-items">
                    {items.length === 0 ? (
                        <div className="no-records">No records</div>
                    ) : (
                        items.map((item, index) => (
                            <div
                                className="kanban-card"
                                key={index}
                                data-card-key={`${columnKey}-${index}`}
                                draggable
                                onDragStart={(e) => this.handleDragStart(e, item, columnKey, index)}
                                onDragEnd={this.handleDragEnd}
                                onDragOver={this.handleDragOverCard}
                                onDragLeave={this.handleDragLeaveCard}
                                onDrop={(e) => this.handleDropOnCard(e, columnKey, index)}
                                onClick={(e) => this.handleCardClick(item, columnKey, e)}
                            >
                                <div className="card-content">
                                    <div className="card-id">{item.identifier}</div>
                                    <div className="card-customer">
                                        <div className="card-label"><i className='ti-user' /> Customer</div>
                                        <span
                                            className="customer-badge"
                                            style={this.getRandomColor(item.customer)}
                                        >
                                            {item.customer}
                                        </span>
                                    </div>
                                    <div className="card-item">
                                        <div className="card-label"><i className='ti-package' /> Product Name</div>
                                        <span className='blank-badge'>{item.productName}</span>
                                    </div>
                                    <div className="card-priority">
                                        <div className="card-label"><i className='ti-package' /> Item Number</div>
                                        <span
                                            className="priority-badge"
                                            style={this.getRandomColor(item.itemNumber)}
                                        >
                                            {item.itemNumber}
                                        </span>
                                    </div>
                                    <div className="card-member">
                                        <div className="card-label"><i className='ti-user' /> {teamMemberLabel}</div>
                                        <span
                                            className="member-badge"
                                            style={this.getRandomColor(item.teamMember)}
                                        >
                                            {item.teamMember}
                                        </span>
                                    </div>
                                    <div className="card-amount">
                                        <div className="card-label"><i className='ti-money' /> {amountLabel}</div>
                                        ${item.orderAmount}
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        );
    }

    render() {
        const { kanbanData, showCreateModal, showLoadExistingModal, showFilterModal, filterConditions, appliedFiltersCount, searchText, loading, itemNumber, itemNumberSearch, selectedSharepointLink, selectedCustomer, customerSearch, selectedOrderType, showItemDropdown, showCustomerDropdown, showMenuDropdown, itemNumbersLoading } = this.state;
        const filteredItemNumbers = this.getFilteredItemNumbers();
        const filteredCustomers = this.getFilteredCustomers();

        return (
            <Layout>
                <div className="overview-container">
                    <div className="overview-header">
                        <p className="overview-title">View and Create new jobs - From RFQ to Final Quote</p>
                        <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
                            <div style={{position: 'relative', display: 'flex', alignItems: 'center'}}>
                                <i className="ti-search" style={{position: 'absolute', left: '12px', color: '#999', fontSize: '14px'}}></i>
                                <input
                                    type="text"
                                    placeholder="Search by Customer, Product, or Item Number..."
                                    value={searchText}
                                    onChange={this.handleSearchChange}
                                    style={{
                                        padding: '8px 35px 8px 35px',
                                        border: '1px solid #e0e0e0',
                                        borderRadius: '4px',
                                        fontSize: '13px',
                                        width: '350px'
                                    }}
                                />
                                {searchText && (
                                    <i
                                        className="ti-close"
                                        onClick={this.handleSearchClear}
                                        style={{
                                            position: 'absolute',
                                            right: '12px',
                                            color: '#999',
                                            fontSize: '12px',
                                            cursor: 'pointer'
                                        }}
                                    ></i>
                                )}
                            </div>
                            <button className="filter-btn" style={{border: '1px solid #e0e0e0', backgroundColor: 'transparent', display: 'flex', alignItems: 'center', gap: '6px', padding: '8px 12px', borderRadius: '4px', cursor: 'pointer'}} onClick={this.handleFilterClick}>
                                <i className="fa-solid fa-sliders"></i> Filters
                                {appliedFiltersCount > 0 && (
                                    <span style={{
                                        backgroundColor: '#5DADE2',
                                        color: 'white',
                                        borderRadius: '10px',
                                        padding: '2px 8px',
                                        fontSize: '11px',
                                        fontWeight: '600'
                                    }}>
                                        {appliedFiltersCount}
                                    </span>
                                )}
                            </button>
                            <button className="all-jobs-btn" style={{border: '1px solid #e0e0e0', backgroundColor: 'transparent', display: 'flex', alignItems: 'center', gap: '6px', padding: '8px 12px', borderRadius: '4px', cursor: 'pointer'}} onClick={this.handleAllJobsClick}>
                                All Jobs
                            </button>
                            <div className="menu-wrapper">
                                <i className="ti-more-alt overview-menu-icon" onClick={this.handleMenuClick}></i>
                                {showMenuDropdown && (
                                    <>
                                        <div className="menu-overlay" onClick={this.handleMenuClose}></div>
                                        <div className="menu-dropdown">
                                            <div className="menu-item" onClick={this.handleMonthlyShippingClick}>
                                                Monthly Shipping Cost
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="kanban-board">
                        {loading ? (
                            <>
                                {this.renderSkeletonColumn('RFQ')}
                                {this.renderSkeletonColumn('R&D')}
                                {this.renderSkeletonColumn('Estimate - Purch. Review')}
                                {this.renderSkeletonColumn('Estimate - Acct. Mgmt. Review')}
                                {this.renderSkeletonColumn('Estimate - Mgmt. Review')}
                                {this.renderSkeletonColumn('Final Quote')}
                                {this.renderSkeletonColumn('Quote Submitted')}
                            </>
                        ) : (
                            <>
                                {this.renderKanbanColumn('RFQ', kanbanData.rfq, 'rfq')}
                                {this.renderKanbanColumn('R&D', kanbanData.rnd, 'rnd')}
                                {this.renderKanbanColumn('Estimate - Purch. Review', kanbanData.draftPurchReview, 'draftPurchReview')}
                                {this.renderKanbanColumn('Estimate - Acct. Mgmt. Review', kanbanData.draftAcctMgmtReview, 'draftAcctMgmtReview')}
                                {this.renderKanbanColumn('Estimate - Mgmt. Review', kanbanData.draftMgmtReview, 'draftMgmtReview')}
                                {this.renderKanbanColumn('Final Quote', kanbanData.finalQuote, 'finalQuote')}
                                {this.renderKanbanColumn('Quote Submitted', kanbanData.quoteSubmitted, 'quoteSubmitted')}
                            </>
                        )}
                    </div>

                    <CreateRecordModal
                        isOpen={showCreateModal}
                        onClose={this.handleCloseModal}
                    />

                    {showFilterModal && (
                        <div className="modal-overlay">
                            <div className="load-existing-modal">
                                <button className="modal-close-btn" onClick={this.handleCloseFilterModal}>×</button>
                                <h3>Filter Records</h3>
                                <p className="modal-subtitle" style={{color: '#999'}}>
                                    {filterConditions.length === 0
                                        ? 'No filter conditions are applied'
                                        : `Showing records that match ${filterConditions.length} condition(s)`}
                                </p>

                                {filterConditions.map((condition, index) => (
                                    <div key={index} className="form-group" style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px',
                                        marginBottom: '15px',
                                        padding: '15px',
                                        border: '1px solid #e0e0e0',
                                        borderRadius: '4px',
                                        backgroundColor: '#f9f9f9'
                                    }}>
                                        <span style={{fontWeight: '500', color: '#666', minWidth: '50px'}}>{index === 0 ? 'Where' : 'And'}</span>
                                        <select
                                            value={condition.field}
                                            onChange={(e) => this.handleFieldChange(index, e.target.value)}
                                            style={{
                                                padding: '8px 12px',
                                                border: '1px solid #e0e0e0',
                                                borderRadius: '4px',
                                                flex: '1',
                                                backgroundColor: 'white'
                                            }}>
                                            <option>Select field</option>
                                            <option>Customer</option>
                                            <option>Product Name</option>
                                            <option>Item Number</option>
                                            <option>Deal Type</option>
                                            <option>Sales Rep</option>
                                            <option>Purchasing Team Member</option>
                                            <option>Assigned To</option>
                                            <option>Quote Priority</option>
                                        </select>
                                        <select
                                            value={condition.operator}
                                            onChange={(e) => this.handleOperatorChange(index, e.target.value)}
                                            style={{
                                                padding: '8px 12px',
                                                border: '1px solid #e0e0e0',
                                                borderRadius: '4px',
                                                flex: '1',
                                                backgroundColor: 'white'
                                            }}>
                                            {(condition.field === 'Deal Type' || condition.field === 'Customer' || condition.field === 'Assigned To' || condition.field === 'Purchasing Team Member' || condition.field === 'Sales Rep' || condition.field === 'Quote Priority') ? (
                                                <>
                                                    <option>is...</option>
                                                    <option>is not...</option>
                                                    <option>is any of...</option>
                                                    <option>is none of...</option>
                                                    <option>is empty...</option>
                                                    <option>is not empty</option>
                                                </>
                                            ) : (
                                                <>
                                                    <option>Equals</option>
                                                    <option>Contains</option>
                                                    <option>Starts with</option>
                                                    <option>Ends with</option>
                                                </>
                                            )}
                                        </select>
                                        {condition.field === 'Deal Type' && ['is...', 'is not...', 'is any of...', 'is none of...'].includes(condition.operator) ? (
                                            <div style={{flex: '1', position: 'relative'}}>
                                                <div
                                                    ref={(el) => this.filterInputRefs[`dealtype_${index}`] = el}
                                                    style={{
                                                        border: '1px solid #e0e0e0',
                                                        borderRadius: '4px',
                                                        padding: '4px 8px',
                                                        backgroundColor: 'white',
                                                        minHeight: '34px',
                                                        display: 'flex',
                                                        flexWrap: 'wrap',
                                                        gap: '4px',
                                                        alignItems: 'center'
                                                    }}>
                                                    {condition.value && condition.value.split('|||').map(name => name.trim()).filter(n => n).map((dealType, idx) => (
                                                        <span key={idx} style={{
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            gap: '4px',
                                                            padding: '2px 8px',
                                                            backgroundColor: '#5DADE2',
                                                            color: 'white',
                                                            borderRadius: '12px',
                                                            fontSize: '12px'
                                                        }}>
                                                            {dealType}
                                                            <i
                                                                className="ti-close"
                                                                onMouseDown={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    this.handleRemoveDealTypeFromFilter(index, dealType);
                                                                }}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    fontSize: '10px'
                                                                }}
                                                            ></i>
                                                        </span>
                                                    ))}
                                                    <input
                                                        type="text"
                                                        placeholder={
                                                            condition.value
                                                                ? (['is...', 'is not...'].includes(condition.operator) ? "Select deal type" : "Add more...")
                                                                : "Select deal types"
                                                        }
                                                        value={this.state.filterDealTypeSearch?.[index] || ''}
                                                        onChange={(e) => this.handleFilterDealTypeSearchChange(index, e.target.value)}
                                                        onFocus={() => this.handleFilterDealTypeFocus(index)}
                                                        onBlur={() => this.handleFilterDealTypeBlur(index)}
                                                        onClick={(e) => {
                                                            e.target.select();
                                                        }}
                                                        style={{
                                                            border: 'none',
                                                            outline: 'none',
                                                            flex: '1',
                                                            minWidth: '120px',
                                                            padding: '4px',
                                                            fontSize: '14px'
                                                        }}
                                                    />
                                                </div>
                                                {this.state.showFilterDealTypeDropdown?.[index] && this.getDealTypeOptions(index).length > 0 && (
                                                    <div style={{
                                                        position: 'fixed',
                                                        top: `${(this.state.filterDropdownPosition[`dealtype_${index}`]?.top || 0) + 2}px`,
                                                        left: `${this.state.filterDropdownPosition[`dealtype_${index}`]?.left || 0}px`,
                                                        background: 'white',
                                                        border: '1px solid #e0e0e0',
                                                        borderRadius: '4px',
                                                        maxHeight: '250px',
                                                        minWidth: '350px',
                                                        overflowY: 'auto',
                                                        zIndex: 99999,
                                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                                                    }}>
                                                        {this.getDealTypeOptions(index).map((dealType, idx) => {
                                                            const selectedDealTypes = condition.value ? condition.value.split('|||').map(s => s.trim()) : [];
                                                            const isSelected = selectedDealTypes.includes(dealType);
                                                            const showCheckbox = ['is any of...', 'is none of...'].includes(condition.operator);
                                                            return (
                                                                <div
                                                                    key={idx}
                                                                    onMouseDown={() => this.handleFilterDealTypeSelect(index, dealType)}
                                                                    style={{
                                                                        padding: '10px 12px',
                                                                        fontSize: '14px',
                                                                        color: '#333',
                                                                        cursor: 'pointer',
                                                                        transition: 'background-color 0.2s ease',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '10px',
                                                                        backgroundColor: isSelected ? '#f0f8ff' : 'white'
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        if (!isSelected) e.currentTarget.style.backgroundColor = '#f5f5f5';
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        e.currentTarget.style.backgroundColor = isSelected ? '#f0f8ff' : 'white';
                                                                    }}
                                                                >
                                                                    {showCheckbox && (
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={isSelected}
                                                                            readOnly
                                                                            style={{
                                                                                cursor: 'pointer',
                                                                                margin: 0,
                                                                                flexShrink: 0,
                                                                                width: '16px',
                                                                                height: '16px'
                                                                            }}
                                                                        />
                                                                    )}
                                                                    <span style={{flex: 1}}>{dealType}</span>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </div>
                                        ) : condition.field === 'Sales Rep' && ['is...', 'is not...', 'is any of...', 'is none of...'].includes(condition.operator) ? (
                                            <div style={{flex: '1', position: 'relative'}}>
                                                <div
                                                    ref={(el) => this.filterInputRefs[`salesrep_${index}`] = el}
                                                    style={{
                                                        border: '1px solid #e0e0e0',
                                                        borderRadius: '4px',
                                                        padding: '4px 8px',
                                                        backgroundColor: 'white',
                                                        minHeight: '34px',
                                                        display: 'flex',
                                                        flexWrap: 'wrap',
                                                        gap: '4px',
                                                        alignItems: 'center'
                                                    }}>
                                                    {condition.value && condition.value.split('|||').map(name => name.trim()).filter(n => n).map((repName, idx) => (
                                                        <span key={idx} style={{
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            gap: '4px',
                                                            padding: '2px 8px',
                                                            backgroundColor: '#5DADE2',
                                                            color: 'white',
                                                            borderRadius: '12px',
                                                            fontSize: '12px'
                                                        }}>
                                                            {repName}
                                                            <i
                                                                className="ti-close"
                                                                onMouseDown={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    this.handleRemoveSalesRepFromFilter(index, repName);
                                                                }}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    fontSize: '10px'
                                                                }}
                                                            ></i>
                                                        </span>
                                                    ))}
                                                    <input
                                                        type="text"
                                                        placeholder={
                                                            condition.value
                                                                ? (['is...', 'is not...'].includes(condition.operator) ? "Select sales rep" : "Add more...")
                                                                : "Select sales reps"
                                                        }
                                                        value={this.state.filterSalesRepSearch?.[index] || ''}
                                                        onChange={(e) => this.handleFilterSalesRepSearchChange(index, e.target.value)}
                                                        onFocus={() => this.handleFilterSalesRepFocus(index)}
                                                        onBlur={() => this.handleFilterSalesRepBlur(index)}
                                                        onClick={(e) => {
                                                            e.target.select();
                                                        }}
                                                        style={{
                                                            border: 'none',
                                                            outline: 'none',
                                                            flex: '1',
                                                            minWidth: '120px',
                                                            padding: '4px',
                                                            fontSize: '14px'
                                                        }}
                                                    />
                                                </div>
                                                {this.state.showFilterSalesRepDropdown?.[index] && this.getFilteredSalesReps(index).length > 0 && (
                                                    <div style={{
                                                        position: 'fixed',
                                                        top: `${(this.state.filterDropdownPosition[`salesrep_${index}`]?.top || 0) + 2}px`,
                                                        left: `${this.state.filterDropdownPosition[`salesrep_${index}`]?.left || 0}px`,
                                                        background: 'white',
                                                        border: '1px solid #e0e0e0',
                                                        borderRadius: '4px',
                                                        maxHeight: '250px',
                                                        minWidth: '350px',
                                                        overflowY: 'auto',
                                                        zIndex: 99999,
                                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                                                    }}>
                                                        {this.getFilteredSalesReps(index).map((rep, idx) => {
                                                            const selectedReps = condition.value ? condition.value.split('|||').map(s => s.trim()) : [];
                                                            const isSelected = selectedReps.includes(rep.fullname);
                                                            const showCheckbox = ['is any of...', 'is none of...'].includes(condition.operator);
                                                            return (
                                                                <div
                                                                    key={idx}
                                                                    onMouseDown={() => this.handleFilterSalesRepSelect(index, rep.fullname)}
                                                                    style={{
                                                                        padding: '10px 12px',
                                                                        fontSize: '14px',
                                                                        color: '#333',
                                                                        cursor: 'pointer',
                                                                        transition: 'background-color 0.2s ease',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '10px',
                                                                        backgroundColor: isSelected ? '#f0f8ff' : 'white'
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        if (!isSelected) e.currentTarget.style.backgroundColor = '#f5f5f5';
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        e.currentTarget.style.backgroundColor = isSelected ? '#f0f8ff' : 'white';
                                                                    }}
                                                                >
                                                                    {showCheckbox && (
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={isSelected}
                                                                            readOnly
                                                                            style={{
                                                                                cursor: 'pointer',
                                                                                margin: 0,
                                                                                flexShrink: 0,
                                                                                width: '16px',
                                                                                height: '16px'
                                                                            }}
                                                                        />
                                                                    )}
                                                                    <span style={{flex: 1}}>{rep.fullname}</span>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </div>
                                        ) : condition.field === 'Purchasing Team Member' && ['is...', 'is not...', 'is any of...', 'is none of...'].includes(condition.operator) ? (
                                            <div style={{flex: '1', position: 'relative'}}>
                                                <div
                                                    ref={(el) => this.filterInputRefs[`purchasing_${index}`] = el}
                                                    style={{
                                                        border: '1px solid #e0e0e0',
                                                        borderRadius: '4px',
                                                        padding: '4px 8px',
                                                        backgroundColor: 'white',
                                                        minHeight: '34px',
                                                        display: 'flex',
                                                        flexWrap: 'wrap',
                                                        gap: '4px',
                                                        alignItems: 'center'
                                                    }}>
                                                    {condition.value && condition.value.split('|||').map(name => name.trim()).filter(n => n).map((userName, idx) => (
                                                        <span key={idx} style={{
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            gap: '4px',
                                                            padding: '2px 8px',
                                                            backgroundColor: '#5DADE2',
                                                            color: 'white',
                                                            borderRadius: '12px',
                                                            fontSize: '12px'
                                                        }}>
                                                            {userName}
                                                            <i
                                                                className="ti-close"
                                                                onMouseDown={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    this.handleRemovePurchasingFromFilter(index, userName);
                                                                }}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    fontSize: '10px'
                                                                }}
                                                            ></i>
                                                        </span>
                                                    ))}
                                                    <input
                                                        type="text"
                                                        placeholder={
                                                            condition.value
                                                                ? (['is...', 'is not...'].includes(condition.operator) ? "Select user" : "Add more...")
                                                                : "Select users"
                                                        }
                                                        value={this.state.filterPurchasingSearch?.[index] || ''}
                                                        onChange={(e) => this.handleFilterPurchasingSearchChange(index, e.target.value)}
                                                        onFocus={() => this.handleFilterPurchasingFocus(index)}
                                                        onBlur={() => this.handleFilterPurchasingBlur(index)}
                                                        onClick={(e) => {
                                                            e.target.select();
                                                        }}
                                                        style={{
                                                            border: 'none',
                                                            outline: 'none',
                                                            flex: '1',
                                                            minWidth: '120px',
                                                            padding: '4px',
                                                            fontSize: '14px'
                                                        }}
                                                    />
                                                </div>
                                                {this.state.showFilterPurchasingDropdown?.[index] && this.getFilteredPurchasingUsers(index).length > 0 && (
                                                    <div style={{
                                                        position: 'fixed',
                                                        top: `${(this.state.filterDropdownPosition[`purchasing_${index}`]?.top || 0) + 2}px`,
                                                        left: `${this.state.filterDropdownPosition[`purchasing_${index}`]?.left || 0}px`,
                                                        background: 'white',
                                                        border: '1px solid #e0e0e0',
                                                        borderRadius: '4px',
                                                        maxHeight: '250px',
                                                        minWidth: '350px',
                                                        overflowY: 'auto',
                                                        zIndex: 99999,
                                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                                                    }}>
                                                        {this.getFilteredPurchasingUsers(index).map((user, idx) => {
                                                            const selectedUsers = condition.value ? condition.value.split('|||').map(s => s.trim()) : [];
                                                            const isSelected = selectedUsers.includes(user.fullname);
                                                            const showCheckbox = ['is any of...', 'is none of...'].includes(condition.operator);
                                                            return (
                                                                <div
                                                                    key={idx}
                                                                    onMouseDown={() => this.handleFilterPurchasingSelect(index, user.fullname)}
                                                                    style={{
                                                                        padding: '10px 12px',
                                                                        fontSize: '14px',
                                                                        color: '#333',
                                                                        cursor: 'pointer',
                                                                        transition: 'background-color 0.2s ease',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '10px',
                                                                        backgroundColor: isSelected ? '#f0f8ff' : 'white'
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        if (!isSelected) e.currentTarget.style.backgroundColor = '#f5f5f5';
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        e.currentTarget.style.backgroundColor = isSelected ? '#f0f8ff' : 'white';
                                                                    }}
                                                                >
                                                                    {showCheckbox && (
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={isSelected}
                                                                            readOnly
                                                                            style={{
                                                                                cursor: 'pointer',
                                                                                margin: 0,
                                                                                flexShrink: 0,
                                                                                width: '16px',
                                                                                height: '16px'
                                                                            }}
                                                                        />
                                                                    )}
                                                                    <span style={{flex: 1}}>{user.fullname}</span>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </div>
                                        ) : condition.field === 'Assigned To' && ['is...', 'is not...', 'is any of...', 'is none of...'].includes(condition.operator) ? (
                                            <div style={{flex: '1', position: 'relative'}}>
                                                <div
                                                    ref={(el) => this.filterInputRefs[`assignedto_${index}`] = el}
                                                    style={{
                                                        border: '1px solid #e0e0e0',
                                                        borderRadius: '4px',
                                                        padding: '4px 8px',
                                                        backgroundColor: 'white',
                                                        minHeight: '34px',
                                                        display: 'flex',
                                                        flexWrap: 'wrap',
                                                        gap: '4px',
                                                        alignItems: 'center'
                                                    }}>
                                                    {condition.value && condition.value.split('|||').map(name => name.trim()).filter(n => n).map((userName, idx) => (
                                                        <span key={idx} style={{
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            gap: '4px',
                                                            padding: '2px 8px',
                                                            backgroundColor: '#5DADE2',
                                                            color: 'white',
                                                            borderRadius: '12px',
                                                            fontSize: '12px'
                                                        }}>
                                                            {userName}
                                                            <i
                                                                className="ti-close"
                                                                onMouseDown={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    this.handleRemoveAssignedToFromFilter(index, userName);
                                                                }}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    fontSize: '10px'
                                                                }}
                                                            ></i>
                                                        </span>
                                                    ))}
                                                    <input
                                                        type="text"
                                                        placeholder={
                                                            condition.value
                                                                ? (['is...', 'is not...'].includes(condition.operator) ? "Select user" : "Add more...")
                                                                : "Select users"
                                                        }
                                                        value={this.state.filterAssignedToSearch?.[index] || ''}
                                                        onChange={(e) => this.handleFilterAssignedToSearchChange(index, e.target.value)}
                                                        onFocus={() => this.handleFilterAssignedToFocus(index)}
                                                        onBlur={() => this.handleFilterAssignedToBlur(index)}
                                                        onClick={(e) => {
                                                            e.target.select();
                                                        }}
                                                        style={{
                                                            border: 'none',
                                                            outline: 'none',
                                                            flex: '1',
                                                            minWidth: '120px',
                                                            padding: '4px',
                                                            fontSize: '14px'
                                                        }}
                                                    />
                                                </div>
                                                {this.state.showFilterAssignedToDropdown?.[index] && this.getFilteredAssignedToUsers(index).length > 0 && (
                                                    <div style={{
                                                        position: 'fixed',
                                                        top: `${(this.state.filterDropdownPosition[`assignedto_${index}`]?.top || 0) + 2}px`,
                                                        left: `${this.state.filterDropdownPosition[`assignedto_${index}`]?.left || 0}px`,
                                                        background: 'white',
                                                        border: '1px solid #e0e0e0',
                                                        borderRadius: '4px',
                                                        maxHeight: '250px',
                                                        minWidth: '350px',
                                                        overflowY: 'auto',
                                                        zIndex: 99999,
                                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                                                    }}>
                                                        {this.getFilteredAssignedToUsers(index).map((user, idx) => {
                                                            const selectedUsers = condition.value ? condition.value.split('|||').map(s => s.trim()) : [];
                                                            const isSelected = selectedUsers.includes(user.fullname);
                                                            const showCheckbox = ['is any of...', 'is none of...'].includes(condition.operator);
                                                            return (
                                                                <div
                                                                    key={idx}
                                                                    onMouseDown={() => this.handleFilterAssignedToSelect(index, user.fullname)}
                                                                    style={{
                                                                        padding: '10px 12px',
                                                                        fontSize: '14px',
                                                                        color: '#333',
                                                                        cursor: 'pointer',
                                                                        transition: 'background-color 0.2s ease',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '10px',
                                                                        backgroundColor: isSelected ? '#f0f8ff' : 'white'
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        if (!isSelected) e.currentTarget.style.backgroundColor = '#f5f5f5';
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        e.currentTarget.style.backgroundColor = isSelected ? '#f0f8ff' : 'white';
                                                                    }}
                                                                >
                                                                    {showCheckbox && (
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={isSelected}
                                                                            readOnly
                                                                            style={{
                                                                                cursor: 'pointer',
                                                                                margin: 0,
                                                                                flexShrink: 0,
                                                                                width: '16px',
                                                                                height: '16px'
                                                                            }}
                                                                        />
                                                                    )}
                                                                    <span style={{flex: 1}}>{user.fullname}</span>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </div>
                                        ) : condition.field === 'Quote Priority' && ['is...', 'is not...', 'is any of...', 'is none of...'].includes(condition.operator) ? (
                                            <div style={{flex: '1', position: 'relative'}}>
                                                <div
                                                    ref={(el) => this.filterInputRefs[`quotepriority_${index}`] = el}
                                                    style={{
                                                        border: '1px solid #e0e0e0',
                                                        borderRadius: '4px',
                                                        padding: '4px 8px',
                                                        backgroundColor: 'white',
                                                        minHeight: '34px',
                                                        display: 'flex',
                                                        flexWrap: 'wrap',
                                                        gap: '4px',
                                                        alignItems: 'center'
                                                    }}>
                                                    {condition.value && condition.value.split('|||').map(name => name.trim()).filter(n => n).map((priority, idx) => (
                                                        <span key={idx} style={{
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            gap: '4px',
                                                            padding: '2px 8px',
                                                            backgroundColor: '#5DADE2',
                                                            color: 'white',
                                                            borderRadius: '12px',
                                                            fontSize: '12px'
                                                        }}>
                                                            {priority}
                                                            <i
                                                                className="ti-close"
                                                                onMouseDown={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    this.handleRemoveQuotePriorityFromFilter(index, priority);
                                                                }}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    fontSize: '10px'
                                                                }}
                                                            ></i>
                                                        </span>
                                                    ))}
                                                    <input
                                                        type="text"
                                                        placeholder={
                                                            condition.value
                                                                ? (['is...', 'is not...'].includes(condition.operator) ? "Select priority" : "Add more...")
                                                                : "Select priorities"
                                                        }
                                                        value={this.state.filterQuotePrioritySearch?.[index] || ''}
                                                        onChange={(e) => this.handleFilterQuotePrioritySearchChange(index, e.target.value)}
                                                        onFocus={() => this.handleFilterQuotePriorityFocus(index)}
                                                        onBlur={() => this.handleFilterQuotePriorityBlur(index)}
                                                        onClick={(e) => {
                                                            e.target.select();
                                                        }}
                                                        style={{
                                                            border: 'none',
                                                            outline: 'none',
                                                            flex: '1',
                                                            minWidth: '120px',
                                                            padding: '4px',
                                                            fontSize: '14px'
                                                        }}
                                                    />
                                                </div>
                                                {this.state.showFilterQuotePriorityDropdown?.[index] && this.getQuotePriorityOptions(index).length > 0 && (
                                                    <div style={{
                                                        position: 'fixed',
                                                        top: `${(this.state.filterDropdownPosition[`quotepriority_${index}`]?.top || 0) + 2}px`,
                                                        left: `${this.state.filterDropdownPosition[`quotepriority_${index}`]?.left || 0}px`,
                                                        background: 'white',
                                                        border: '1px solid #e0e0e0',
                                                        borderRadius: '4px',
                                                        maxHeight: '250px',
                                                        minWidth: '350px',
                                                        overflowY: 'auto',
                                                        zIndex: 99999,
                                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                                                    }}>
                                                        {this.getQuotePriorityOptions(index).map((priority, idx) => {
                                                            const selectedPriorities = condition.value ? condition.value.split('|||').map(s => s.trim()) : [];
                                                            const isSelected = selectedPriorities.includes(priority);
                                                            const showCheckbox = ['is any of...', 'is none of...'].includes(condition.operator);
                                                            return (
                                                                <div
                                                                    key={idx}
                                                                    onMouseDown={() => this.handleFilterQuotePrioritySelect(index, priority)}
                                                                    style={{
                                                                        padding: '10px 12px',
                                                                        fontSize: '14px',
                                                                        color: '#333',
                                                                        cursor: 'pointer',
                                                                        transition: 'background-color 0.2s ease',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '10px',
                                                                        backgroundColor: isSelected ? '#f0f8ff' : 'white'
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        if (!isSelected) e.currentTarget.style.backgroundColor = '#f5f5f5';
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        e.currentTarget.style.backgroundColor = isSelected ? '#f0f8ff' : 'white';
                                                                    }}
                                                                >
                                                                    {showCheckbox && (
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={isSelected}
                                                                            readOnly
                                                                            style={{
                                                                                cursor: 'pointer',
                                                                                margin: 0,
                                                                                flexShrink: 0,
                                                                                width: '16px',
                                                                                height: '16px'
                                                                            }}
                                                                        />
                                                                    )}
                                                                    <span style={{flex: 1}}>{priority}</span>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </div>
                                        ) : condition.field === 'Customer' && ['is...', 'is not...', 'is any of...', 'is none of...'].includes(condition.operator) ? (
                                            <div style={{flex: '1', position: 'relative'}}>
                                                <div
                                                    ref={(el) => this.filterInputRefs[index] = el}
                                                    style={{
                                                        border: '1px solid #e0e0e0',
                                                        borderRadius: '4px',
                                                        padding: '4px 8px',
                                                        backgroundColor: 'white',
                                                        minHeight: '34px',
                                                        display: 'flex',
                                                        flexWrap: 'wrap',
                                                        gap: '4px',
                                                        alignItems: 'center'
                                                    }}>
                                                    {condition.value && condition.value.split('|||').map(name => name.trim()).filter(n => n).map((customerName, idx) => (
                                                        <span key={idx} style={{
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            gap: '4px',
                                                            padding: '2px 8px',
                                                            backgroundColor: '#5DADE2',
                                                            color: 'white',
                                                            borderRadius: '12px',
                                                            fontSize: '12px'
                                                        }}>
                                                            {customerName}
                                                            <i
                                                                className="ti-close"
                                                                onMouseDown={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    this.handleRemoveCustomerFromFilter(index, customerName);
                                                                }}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    fontSize: '10px'
                                                                }}
                                                            ></i>
                                                        </span>
                                                    ))}
                                                    <input
                                                        type="text"
                                                        placeholder={
                                                            condition.value
                                                                ? (['is...', 'is not...'].includes(condition.operator) ? "Select customer" : "Add more...")
                                                                : "Select customers"
                                                        }
                                                        value={this.state.filterCustomerSearch[index] || ''}
                                                        onChange={(e) => this.handleFilterCustomerSearchChange(index, e.target.value)}
                                                        onFocus={() => this.handleFilterCustomerFocus(index)}
                                                        onBlur={() => this.handleFilterCustomerBlur(index)}
                                                        onClick={(e) => {
                                                            e.target.select();
                                                        }}
                                                        style={{
                                                            border: 'none',
                                                            outline: 'none',
                                                            flex: '1',
                                                            minWidth: '120px',
                                                            padding: '4px',
                                                            fontSize: '14px'
                                                        }}
                                                    />
                                                </div>
                                                {this.state.showFilterCustomerDropdown[index] && this.getFilteredCustomersForFilter(index).length > 0 && (
                                                    <div style={{
                                                        position: 'fixed',
                                                        top: `${(this.state.filterDropdownPosition[index]?.top || 0) + 2}px`,
                                                        left: `${this.state.filterDropdownPosition[index]?.left || 0}px`,
                                                        background: 'white',
                                                        border: '1px solid #e0e0e0',
                                                        borderRadius: '4px',
                                                        maxHeight: '250px',
                                                        minWidth: '350px',
                                                        overflowY: 'auto',
                                                        zIndex: 99999,
                                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                                                    }}>
                                                        {this.getFilteredCustomersForFilter(index).map((customer, idx) => {
                                                            const selectedCustomers = condition.value ? condition.value.split('|||').map(s => s.trim()) : [];
                                                            const isSelected = selectedCustomers.includes(customer.customer_name);
                                                            const showCheckbox = ['is any of...', 'is none of...'].includes(condition.operator);
                                                            return (
                                                                <div
                                                                    key={idx}
                                                                    onMouseDown={() => this.handleFilterCustomerSelect(index, customer.customer_name)}
                                                                    style={{
                                                                        padding: '10px 12px',
                                                                        fontSize: '14px',
                                                                        color: '#333',
                                                                        cursor: 'pointer',
                                                                        transition: 'background-color 0.2s ease',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '10px',
                                                                        backgroundColor: isSelected ? '#f0f8ff' : 'white'
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        if (!isSelected) e.currentTarget.style.backgroundColor = '#f5f5f5';
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        e.currentTarget.style.backgroundColor = isSelected ? '#f0f8ff' : 'white';
                                                                    }}
                                                                >
                                                                    {showCheckbox && (
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={isSelected}
                                                                            readOnly
                                                                            style={{
                                                                                cursor: 'pointer',
                                                                                margin: 0,
                                                                                flexShrink: 0,
                                                                                width: '16px',
                                                                                height: '16px'
                                                                            }}
                                                                        />
                                                                    )}
                                                                    <span style={{flex: 1}}>{customer.customer_name}</span>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            <input
                                                type="text"
                                                placeholder={
                                                    (condition.field === 'Deal Type' || condition.field === 'Customer' || condition.field === 'Assigned To' || condition.field === 'Purchasing Team Member' || condition.field === 'Sales Rep' || condition.field === 'Quote Priority') && ['is empty...', 'is not empty'].includes(condition.operator)
                                                        ? "No value needed"
                                                        : "Enter a value"
                                                }
                                                value={condition.value}
                                                onChange={(e) => this.handleValueChange(index, e.target.value)}
                                                style={{
                                                    padding: '8px 12px',
                                                    border: '1px solid #e0e0e0',
                                                    borderRadius: '4px',
                                                    flex: '1'
                                                }}
                                                disabled={(condition.field === 'Deal Type' || condition.field === 'Customer' || condition.field === 'Assigned To' || condition.field === 'Purchasing Team Member' || condition.field === 'Sales Rep' || condition.field === 'Quote Priority') && ['is empty...', 'is not empty'].includes(condition.operator)}
                                            />
                                        )}
                                        <i
                                            className="ti-trash"
                                            style={{cursor: 'pointer', fontSize: '18px', color: '#999'}}
                                            onClick={() => this.handleRemoveCondition(index)}
                                        ></i>
                                    </div>
                                ))}

                                <div className="form-group" style={{display: 'flex', gap: '10px', marginTop: '20px'}}>
                                    <button className="add-condition-btn" onClick={this.handleAddCondition} style={{
                                        border: '1px solid #e0e0e0',
                                        backgroundColor: 'transparent',
                                        padding: '8px 16px',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        fontSize: '13px'
                                    }}>
                                        <span style={{fontSize: '16px'}}>+</span> Add condition
                                    </button>
                                    {appliedFiltersCount > 0 && (
                                        <button className="add-condition-btn" onClick={this.handleClearAndApplyFilters} style={{
                                            border: '1px solid #e0e0e0',
                                            backgroundColor: 'transparent',
                                            padding: '8px 16px',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            fontSize: '13px'
                                        }}>
                                            <span style={{fontSize: '16px'}}>×</span> Clear all filters
                                        </button>
                                    )}
                                </div>

                                <div className="form-actions" style={{display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px'}}>
                                    <button className="modal-cancel" onClick={this.handleCloseFilterModal} style={{padding: '8px 16px', fontSize: '13px'}}>
                                        Cancel
                                    </button>
                                    <button className="load-rfq-btn" onClick={this.handleApplyFilter} style={{backgroundColor: '#5DADE2', padding: '6px 14px', fontSize: '12px', lineHeight: '1'}}>
                                        Apply Filter
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {showLoadExistingModal && (
                        <div className="modal-overlay">
                            <div className="load-existing-modal">
                                <button className="modal-close-btn" onClick={this.handleCloseLoadExistingModal}>×</button>
                                <h3>Load Existing Formula</h3>
                                <p className="modal-subtitle">Search for an item number and select a customer to load the formula</p>

                                <div className="form-group">
                                    <label>Enter Item Number</label>
                                    <div className="searchable-select">
                                        <div className="input-with-icon">
                                            <i className="ti-search"></i>
                                            <input
                                                type="text"
                                                style={{padding:'10px 12px 10px 30px'}}
                                                placeholder={itemNumbersLoading ? "Loading..." : "1953-Pack-120"}
                                                value={itemNumberSearch}
                                                onChange={this.handleItemNumberSearchChange}
                                                onFocus={this.handleItemNumberFocus}
                                                onBlur={this.handleItemNumberBlur}
                                                disabled={itemNumbersLoading}
                                            />
                                        </div>
                                        {showItemDropdown && itemNumbersLoading && (
                                            <div className="dropdown-list">
                                                <div className="dropdown-item" style={{textAlign: 'center', color: '#999'}}>
                                                    Loading item numbers...
                                                </div>
                                            </div>
                                        )}
                                        {showItemDropdown && !itemNumbersLoading && filteredItemNumbers.length > 0 && (
                                            <div className="dropdown-list">
                                                {filteredItemNumbers.map((item, index) => (
                                                    <div
                                                        key={index}
                                                        className="dropdown-item"
                                                        onClick={() => this.handleItemNumberSelect(item)}
                                                    >
                                                        {item.itemNumber}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {itemNumber && selectedSharepointLink && (
                                    <div className="form-group">
                                        <label>Latest Sharepoint Link</label>
                                        <div className="sharepoint-link-container">
                                            <div className="sharepoint-link-wrapper">
                                                <i className="ti-link"></i>
                                                <input
                                                    type="text"
                                                    style={{padding:'10px 12px 10px 30px'}}
                                                    className="sharepoint-link-input"
                                                    value={selectedSharepointLink}
                                                    readOnly
                                                />
                                            </div>
                                            <i
                                                className="ti-new-window sharepoint-open-icon"
                                                onClick={() => window.open(selectedSharepointLink, '_blank')}
                                                title="Open in new tab"
                                            ></i>
                                        </div>
                                    </div>
                                )}

                                {itemNumber && (
                                    <div className="form-group">
                                        <label>Select Customer</label>
                                        <div className="searchable-select">
                                            <div className="input-with-icon">
                                                <i className="ti-search"></i>
                                                <input
                                                    type="text"
                                                    style={{padding:'10px 12px 10px 30px'}}
                                                    placeholder="VitalWell Labs"
                                                    value={customerSearch}
                                                    onChange={this.handleCustomerSearchChange}
                                                    onFocus={this.handleCustomerFocus}
                                                    onBlur={this.handleCustomerBlur}
                                                />
                                            </div>
                                            {showCustomerDropdown && filteredCustomers.length > 0 && (
                                                <div className="dropdown-list">
                                                    {filteredCustomers.map((customer, index) => (
                                                        <div
                                                            key={index}
                                                            className="dropdown-item"
                                                            onClick={() => this.handleCustomerSelect(customer)}
                                                        >
                                                            {customer.customer_name}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {itemNumber && selectedCustomer && (
                                    <div className="form-group">
                                        <label>Order Type</label>
                                        <select
                                            value={selectedOrderType}
                                            onChange={this.handleOrderTypeChange}
                                            className="order-type-select"
                                        >
                                            <option value="">Select Order Type</option>
                                            <option value="Reorder">Reorder</option>
                                            <option value="NPD">NPD</option>
                                            <option value="Re-Formulation">Re-Formulation</option>
                                            <option value="New to APEX Product">New to APEX Product</option>
                                            <option value="Blanket">Blanket</option>
                                            <option value="Re-Formulation">Re-Formulation</option>
                                            <option value="Change Order">Change Order</option>
                                        </select>
                                    </div>
                                )}

                                {itemNumber && selectedCustomer && selectedOrderType && (
                                    <div className="form-actions">
                                        <button className="load-rfq-btn" onClick={this.handleLoadExistingSubmit}>
                                            Load RFQ
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </Layout>
        );
    }
}

export default Overview;
